import { Theme } from "@material-ui/core/styles";
import { ButtonProps } from "./button.interface";

export const getBackgroundColor = ({
  variant,
  color,
  buttonType,
}: ButtonProps) => {
  if (variant === "outlined" && buttonType === "tertiary") return "#F1F5FF";
  if (variant === "contained") return "#0344DC";
  if (variant === "outlined") return "transparent";
  if (variant === "text") return "transparent";
  return color;
};

export const getBorderColor = ({ variant, color, buttonType }: ButtonProps) => {
  if (variant === "outlined" && buttonType === "tertiary")
    return "1px solid #F1F5FF";
  if (variant === "contained") return "1px solid #0344DC";
  if (variant === "outlined") return "1px solid #0344DC";
  if (variant === "text") return "none";
  return color;
};

export const getColor = ({ variant, color }: ButtonProps, theme: Theme) => {
  if (variant === "contained") return theme.palette.common.white;
  if (variant === "outlined") return "#0344DC";
  if (variant === "text") return "#0344DC";
  return color;
};

export const getBackgroundHoverColor = ({
  variant,
  color,
  buttonType,
}: ButtonProps) => {
  if (variant === "outlined" && buttonType === "tertiary") return "#E9EEFD";
  if (variant === "contained") return "#0236B0";
  if (variant === "outlined") return "#F5F8FF";
  if (variant === "text") return "transparent";
  return color;
};
